import { useBoundValue } from "lib/@components/binding/use-bound-value.js"
import {
    LAWS,
    RULES,
    FACILITY_TYPES,
    SCHEDULE_LIBRARY_PREFERENCE_LABELS,
} from "routes/asset-register/plugins/asset-mapping/constants.js"

export function useMappingSettingsWizardSummaries() {
    const [english] = useBoundValue("english", false)
    const [welsh] = useBoundValue("welsh", false)
    const [scottish] = useBoundValue("scottish", false)
    const [northernIreland] = useBoundValue("northernIreland", false)

    const [healthcare] = useBoundValue("healthcare", false)
    const [mothballing] = useBoundValue("mothballing", false)
    const [reactivation] = useBoundValue("reactivation", false)

    const [originalTypes] = useBoundValue("originalTypes", false)
    const [mappingRule] = useBoundValue("mappingRule", "strict")
    const [scheduleLibraryPreference] = useBoundValue("scheduleLibraryPreference", "all")

    return {
        legislationSummary: formatValues([
            english && LAWS.english,
            welsh && LAWS.welsh,
            scottish && LAWS.scottish,
            northernIreland && LAWS.northernIreland,
        ]),
        facilityTypeSummary: formatValues([
            healthcare && FACILITY_TYPES.healthcare,
            mothballing && FACILITY_TYPES.mothballing,
            reactivation && FACILITY_TYPES.reactivation,
        ]),
        assetTypeSummary: originalTypes ? "Unrefined Types" : "Computed Types",
        confidenceThresholdSummary: RULES[mappingRule]?.label || RULES.strict.label,
        scheduleTypePreferenceSummary:
            SCHEDULE_LIBRARY_PREFERENCE_LABELS[scheduleLibraryPreference] || SCHEDULE_LIBRARY_PREFERENCE_LABELS.all,
    }
}

function formatValues(values) {
    const selected = values.filter(Boolean)
    return selected.length ? selected.join(", ") : "None selected"
}
